import React, { HTMLAttributes } from 'react';
import { useMst } from '../models/WithWineState';
import { useObserver } from 'mobx-react-lite';
import { RandomStringGenerator, CharSet } from '../utils/randomString';
import styled from 'styled-components/macro';
import { getEnv } from 'mobx-state-tree';

const randomStr = () => {
  const generator = new RandomStringGenerator(CharSet.ALPHANUMERIC);
  return generator.generate(6);
};

const UnstyledMenuAuthLink: React.FC<HTMLAttributes<HTMLAnchorElement>> = ({
  className,
}) => {
  const state = useMst();
  const env = getEnv(state);
  const websiteBaseUrl = env.websiteBaseUrl ?? '';

  return useObserver(() =>
    state.session?.authenticated ? (
      <a
        href={`${websiteBaseUrl}/user/logout?cb=${randomStr()}&from=${escape(
          window.location.href,
        )}`}
        className={'ww-widget ww-menu-auth-link ' + (className ?? '')}
      >
        Logout{' '}
        {state.session?.user?.name ? (
          <span className="ww-user-name">{state.session?.user?.name}</span>
        ) : (
          ''
        )}
      </a>
    ) : (
      <a
        href={`${websiteBaseUrl}/user/login?cb=${randomStr()}&login_info=login&from=${escape(
          window.location.href,
        )}`}
        className={'ww-widget ww-menu-auth-link ' + (className ?? '')}
      >
        Login
      </a>
    ),
  );
};

export default styled(UnstyledMenuAuthLink)`
  font-size: inherit;
  font-family: inherit;
`;
